// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2RulesMemberNumberBucketResult {
    static getAttributeTypeMap() {
        return EnrollmentV2RulesMemberNumberBucketResult.attributeTypeMap;
    }
}
EnrollmentV2RulesMemberNumberBucketResult.discriminator = undefined;
EnrollmentV2RulesMemberNumberBucketResult.additionalProperties = false;
EnrollmentV2RulesMemberNumberBucketResult.attributeTypeMap = [
    {
        "name": "bucketName",
        "baseName": "bucketName",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentV2RulesMemberNumberBucketResult.js.map